import styled from '@emotion/styled';
import SPACING from '@zola/zola-ui/src/styles/emotion/spacing';
import { PhotoIcon as Photo } from '@zola/zola-ui/src/components/SvgIconsV3/Photo';
import { ButtonV3 } from '@zola/zola-ui/src/components/ButtonV3';

export const PreviewIcon = styled.img`
  width: 38px;
  height: 38px;
  margin-right: 18px;
  border-radius: 50%;
  object-fit: cover;
  border: 1px solid white;
  padding: 1px;
`;

export const PhotoIcon = styled(Photo)`
  margin-right: ${SPACING.XS};
`;

export const StyledButton = styled(ButtonV3)`
  white-space: nowrap;
`;
